import { AttributeFieldProps } from "./RenderAttributeInput";
import { GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import SelectDropdown from "../SelectDropdown";


export default function SelectField({
  label,
  definition,
  layoutObject,
  updateFunc,
  saveFunc,
  screenSize,
  extraClass,
  allowFilter
}: AttributeFieldProps & { extraClass?: string,allowFilter?:boolean }) {
  let key = definition.attKey;

  let val = GetComponentOrStyleValueFromDefinition(
    definition,
    layoutObject,
    screenSize
  );

  
  const triggerChange = (val: string) => {
    updateFunc(key, val, definition.targetType);
    saveFunc();
  };



  return (
    <div className={"wb-input-group single-line " + (extraClass ?? "")}>
      <label className={val==""?"not-updated":"updated"}>{label}</label>
   
      <SelectDropdown
        key={"select-dropdown-" + key+layoutObject.id}
        options={definition.options}
        defaultValue={val}
        allowFilter = {allowFilter}
        onChange={triggerChange}
      />
    </div>
  );
}
